import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { migrateDatabase, migrateStorageKeys } from '@/app/brand-migration'
import { HotkeysProvider } from '@/app/hotkeys-provider'
import { SessionProvider } from '@/app/session-provider'
import { applyTheme, readTheme } from '@/app/theme'
import { ApiError } from '@/shared/api'
import { routeTree } from './routeTree.gen'
import './styles.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Каса стоїть відкритою цілу зміну: рефетч на фокус — це те, що показує
      // «видали на іншому терміналі» без F5.
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      // 4xx означає, що запит був неправильний або не дозволений — ретрай лише
      // відкладає повідомлення. Мережеві збої варті другої спроби.
      retry: (failureCount, error) =>
        error instanceof ApiError && error.status < 500 ? false : failureCount < 2,
    },
  },
})

const router = createRouter({ routeTree, defaultPreload: 'intent', scrollRestoration: true })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

/// Переїзд даних із `zala` на `eatlete` — ДО першого читання (D117).
///
/// Ключі сховища переносяться синхронно, бо тему читають рядком нижче. База —
/// з очікуванням: у ній лежить черга непроведених продажів, і застосунок не має
/// права відкритись раніше, ніж вона переїде, інакше він щиро покаже «черга
/// порожня» над чужими грішми.
migrateStorageKeys()
await migrateDatabase()

applyTheme(readTheme())

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('#root is missing from index.html')

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <HotkeysProvider>
          <RouterProvider router={router} />
        </HotkeysProvider>
      </SessionProvider>
    </QueryClientProvider>
  </StrictMode>,
)
